import _ from 'lodash';
import React, { useContext, useReducer } from "react";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { sportsEditMatchHandlers, sportsEditMatchInitialState, sportsEditMatchReducer } from "../reducers/SportsEditMatchReducer";
import { SeasonMatchesContext } from "./SeasonMatchesContext";
import { SportsMatchContext } from "./SportsMatchContext";
import { SportsSeasonContext } from "./SportsSeasonContext";

export const SportsEditMatchContext = React.createContext()

export default function SportsEditMatchProvider(props) {

  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { mainRt } = app_state ?? {}
  const { pathViews } = paps_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, matches_info, sportPermissions, sportDataSettings, _sportData, currentUserId } = sportsSeason_state ?? {}
  const { matches_playoffs } = matches_info ?? {}
  const { latestSeason, sportsKey, gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)

  const componentContexts = { sportsSeasonContext, seasonMatchesContext }

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true } = sportsMatch_state ?? {}

  const init_state = {
    _sportData,
    currentUserId,
    gameScoringType,
    latestSeason,
    match_true,
    match_edit: props?.match || match_true,
    pathViews,
    matches_playoffs,
    sportDataSettings,
    sportPermissions,
    sportsKey,
    fn_cls,
    mainRt,
    matchUpdateType: props.matchUpdateType,
    matchResultType: props.matchResultType,
  }

  const [sportsEditMatch_state, sportsMatchRealtime_dispatch] = useReducer(sportsEditMatchReducer, init_state, sportsEditMatchInitialState)
  const sportsEditMatch_handlers = sportsEditMatchHandlers(sportsMatchRealtime_dispatch, sportsEditMatch_state)

  return <SportsEditMatchContext.Provider value={{ sportsEditMatch_state, sportsEditMatch_handlers, componentContexts }}>
    {props.children}
  </SportsEditMatchContext.Provider>
}